import { styled } from '@precis-digital/kurama/utils'
import Typography from '@precis-digital/kurama/Typography'

const StyledTypographyNoWrap = styled(Typography)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  marginRight: theme.spacing(2),
  maxWidth: '100%',
  width: 'content-fit'
}))

export default StyledTypographyNoWrap
